import React, { useEffect, useState } from "react";
import { useField } from "formik";
import "./FileUpload.css";
import upload from "../../images/icons/upload.png";
import api from "../../api/api";
import apiUtil from "../../api/apiUtil";
import getToken from "../../pages/getToken";

const MAX_COUNT = 5;

const FileUpload = (props) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileLimit, setFileLimit] = useState(false);

  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error;
  const { value } = meta;

  let fileArray = [];
  const [fileObjects, setFileObjects] = useState(value ? fileArray : {});

  const [imageSize, setImageSize] = useState([]);
  const getImageSize = () => {
    api
      .get("Admin/GetSettingDetailByAdmin", { Name: "LogoSize" }, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response.data.data);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setImageSize(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            setImageSize([]);
            console.log(error);
          }
        )
      );
  };

  // const handleUploadFiles = (files) => {
  //   debugger;

  //   const uploaded = [...uploadedFiles];
  //   let limitExceeded = false;    
  //   files.some((file) => {
  //     if (uploaded.findIndex((f) => f.name === file.name) === -1) {
  //       if (uploaded.length === MAX_COUNT) setFileLimit(true);
  //       if (uploaded.length > MAX_COUNT) {
  //         alert(`You can only add a maximum of ${MAX_COUNT} files`);
  //         setFileLimit(false);
  //         limitExceeded = true;
  //         return true;
  //       }  
  //       uploaded.push(file);
  //     }
  //   });
  //   if (!limitExceeded) setUploadedFiles(uploaded);
  // };

  const handleFileEvent = (e) => {
    debugger;
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    const maxSizeInBytes = imageSize.valueInInt? (imageSize.valueInInt * 1024 * 1024) : (5 * 1024 * 1024);
    const validFiles = chosenFiles.filter(file => file.size <= maxSizeInBytes);

    // handleUploadFiles(validFiles);

    const fileArray = [];
    if (validFiles.length > 0) {
      for (let i = 0; i < validFiles.length; i++) {
        let file = validFiles[i];
        fileArray.push({ name: file.name, file: URL.createObjectURL(file) });
      }

      setFileObjects(fileArray);
      props.handleFile(validFiles);
    } else {
      alert(`Image size exceeds ${imageSize.valueInInt ? imageSize.valueInInt : 5} MB limit. Please choose a smaller one!`);
      return false;
    }
  };

  useEffect(() => {
    getImageSize();
    if (value == null || value == "" || value == "-") {
      helpers.setValue(null);
      setFileObjects({});
      props.refPreviewFiles.current = false;
    } else {
      helpers.setValue(value);
      fileArray.push({ name: "", file: value });
      setFileObjects(fileArray);
      props.refPreviewFiles.current = true;
    }
  }, [value]);

  return (
    <div className="fileUploadHolder">
      <label htmlFor="fileUpload" className="label">
        {props.label}
      </label>

      <div className="fileUploadInput">
        <div ref={props.refPreviewFiles} className="uploaded-files-list">
          {fileObjects.length > 0 && props.refPreviewFiles.current ? (
            fileObjects.map((file, index) => (
              <div className="preview_holder" key={`file_upload_${file.name}_${index}`}>
                <label>{file.name}</label> <img src={file.file} alt="img" />
              </div>
            ))
          ) : (
            <span className="placeholder-text">{props.placeholder}</span>
          )}
        </div>
        <label htmlFor="fileUpload" className="uploadTrigger">
          <a className={` ${!fileLimit ? "" : "disabled"} cursor-pointer`}>
            <img src={upload} className="upload_icon" alt="" />
          </a>
        </label>
      </div>
      <input
        id="fileUpload"
        type="file"
        name={props.name}
        {...field}
        multiple={props.multiple}
        // accept="application/pdf, image/png"
        value={props.value}
        accept="image/*"
        onChange={handleFileEvent}
        disabled={fileLimit}
      />
      {hasError ? (
        <div className="error__text">{props.customError || meta.error}</div>
      ) : null}
    </div>
  );
};

export default FileUpload;
